import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import PixelTrail from "./components/PixelTrail";
import {
    Home,
    Privacy,
    Contact
} from "./pages";

function App() {
    return (
        <div className="min-h-screen bg-[#0E101D] font-vt323 overflow-x-hidden flex flex-col">
            {/* Global Pixel Trail Cursor Effect */}
            <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 9999, pointerEvents: 'none' }}>
                <PixelTrail
                    gridSize={40}
                    trailSize={0.01}
                    maxAge={10}
                    interpolate={5}
                    color="#ffffff"
                />
            </div>
            <Router>
                <Header />
                <main className="flex-grow">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/contact" element={<Contact />} />
                    </Routes>
                </main>
                <Footer />
            </Router>
            <Analytics />
        </div>
    );
}

export default App;
